import { TabsWithUnderline } from "@truevault/aquilo";
import React from "react";
import { useHistory } from "react-router";
import { Routes } from "../../../../root/routes";

export type HRDataMapTabKey =
  | "employee-collection"
  | "employee-recipients"
  | "employee-disclosures"
  | "employee-sources"
  | "employee-data-access"
  | "employee-exceptions";

const TABS_CONFIG: { tabKey: string; name: string; route: string }[] = [
  {
    name: "Collection",
    route: Routes.hrCenter.hrDataMap.employeeCollection,
    tabKey: "employee-collection",
  },
  {
    name: "Recipients",
    route: Routes.hrCenter.hrDataMap.employeeRecipients,
    tabKey: "employee-recipients",
  },
  {
    name: "Disclosures",
    route: Routes.hrCenter.hrDataMap.employeeDisclosures,
    tabKey: "employee-disclosures",
  },
  {
    name: "Sources",
    route: Routes.hrCenter.hrDataMap.employeeSources,
    tabKey: "employee-sources",
  },
  {
    name: "Access",
    route: Routes.hrCenter.hrDataMap.employeeDataAccess,
    tabKey: "employee-data-access",
  },
  {
    name: "Exceptions",
    route: Routes.hrCenter.hrDataMap.employeeExceptions,
    tabKey: "employee-exceptions",
  },
];

// Note that `enableAllTabs` will override `enableNextTab` if the former is `true` and the latter is `false`
export function HRDataMapTabs({
  selectedTabKey,
  marginBottomPx = 24,
  enableNextTab = true,
  enableAllTabs = true,
}: {
  selectedTabKey: HRDataMapTabKey;
  enableNextTab?: boolean; // whether the tab immediate to the right of the current tab should be enabled
  enableAllTabs?: boolean; // whether all tabs should be enabled
  marginBottomPx?: number;
}) {
  const history = useHistory();

  let selectedTabIdx = TABS_CONFIG.findIndex((tabConfig) => tabConfig.tabKey === selectedTabKey);

  const tabs = (
    <TabsWithUnderline
      tabs={TABS_CONFIG.map((tabConfig, idx) => {
        // `tab` is enabled if (1) it is the current tab, (2) before the current tab, (3) it is the next tab and `enableNextTab` is true, or (4) `enableAllTabs` is true
        let enabled = false;
        if (tabConfig.tabKey === selectedTabKey) {
          enabled = true;
        } else if (idx < selectedTabIdx) {
          enabled = true;
        } else if (idx === selectedTabIdx + 1 && enableNextTab) {
          enabled = true;
        } else if (enableAllTabs) {
          enabled = true;
        }

        return {
          name: tabConfig.name,
          current: tabConfig.tabKey === selectedTabKey,
          onClick: () => {
            if (enabled) {
              history.push(tabConfig.route);
            }
          },
          disabled: !enabled,
        };
      })}
    />
  );

  return (
    <div className="tw-boundary" style={{ marginBottom: `${marginBottomPx}px` }}>
      {tabs}
    </div>
  );
}
